import { render } from "./‏‏EditAlerts.vue?vue&type=template&id=7979d834&scoped=true"
import script from "./‏‏EditAlerts.vue?vue&type=script&lang=js"
export * from "./‏‏EditAlerts.vue?vue&type=script&lang=js"

import "./‏‏EditAlerts.vue?vue&type=style&index=0&id=7979d834&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7979d834"]])

export default __exports__